import { GrupoUsuario } from '../usuario/types';

import { RequestListagemProps } from 'hooks/useRequestListagem';
import { Cluster } from 'pages/complementar/cluster/types';

export interface Cep {
    idCep: number;
    cidade: {
        idCidade: number;
        dsCidade: string;
        nrIbge: number;
        estado: {
            idEstado: number;
            dsEstado: string;
            sgEstado: string;
            sgEstadoName: string;
        };
        sgEstado: string;
    };
    nrCep: string;
    estado: {
        idEstado: number;
        dsEstado: string;
        sgEstado: string;
        sgEstadoName: string;
    };
    sgEstado: string;
    dsCidade: string;
    dsBairro: string;
    dsEndereco: string;
}

interface TipoLoja {
    idTipoLoja: number;
}
export interface GrupoUsuarioColunas {
    grupoUsuario?: {
        idGrupoUsuario: number | null;
        dsGrupoUsuario: string | null;
    };

    idGrupoUsuario?: number | null;
    dsGrupoUsuario?: string | null;
}
export interface GrupoExibicaoProps {
    idConfiguracaoPropriedadeGrupoExibicao?: number | null;
    dsConfiguracaoPropriedadeGrupoExibicao: string;
    nrSequencia: number | string;
    fgReordena: boolean;
    fgAtivo?: boolean;
    configuracaoPropriedadeGrupoExibicaoGrupoUsuario?: GrupoUsuarioColunas[];
}
export interface OpcaoProps {
    idConfiguracaoPropriedadeOpcao?: number;
    dsConfiguracaoPropriedadeOpcao: string;
    vlConfiguracaoPropriedadeOpcao?: string;
    dsChave: string;
    nrSequencia: string;
}
export interface ColunaDinamicaProps {
    idConfiguracao?: string | null | number;
    idConfiguracaoPropriedade?: number;
    dsConfiguracao: string;
    nrSequencia: string;
    fgReordena: boolean;
    fgAtivo: boolean;
    dsChave: string;
    dsValor?: string | null;
    tipoConfiguracaoPropriedade?: {
        idTipoConfiguracaoPropriedade: number;
        dsTipoConfiguracaoPropriedade: string;
        tipoConfiguracaoPropriedadeEnum?: string;
    };
    configuracaoPropriedade?: {
        idConfiguracaoPropriedade?: number;
    };
    configuracaoPropriedadeGrupoExibicao?: {
        idConfiguracaoPropriedadeGrupoExibicao?: string;
        dsConfiguracaoPropriedadeGrupoExibicao?: string;
    };
    tipoConfiguracaoPropriedadeEnum?: string;
    configuracaoPropriedadeOpcaoList?: [{ idConfiguracaoPropriedadeOpcao?: string; dsConfiguracaoPropriedadeOpcao?: string }];
    tipoConfiguracaoPropriedadeOpcao: boolean;
}
export interface LojaBandaPreco {
    bandaPreco: {
        idBandaPreco: number;
        dsBandaPreco?: string;
    };
    idBandaPreco: number;
    dsBandaPreco: string;
    vlPercentual: number;
    fgAtivo: boolean;
}

export interface LojaConfiguracao {
    idConfiguracaoPropriedade: number;
    dsConfiguracao: string;
    dsChave: string;
    idLojaConfiguracao?: number;
    dsValor?: string;
    configuracaoPropriedade: {
        idConfiguracaoPropriedade: number;
        dsConfiguracao: string;
        dsChave: string;
    };
}

interface GrupoEconomicoLoja {
    fgAtivo: boolean;
    idGrupoEconomicoLoja: number;
    idGrupoEconomico: number;
    dsGrupoEconomico: string;
}

interface FaixaFaturamento {
    idFaixaFaturamento: number;
    dsFaixaFaturamento: string;
}

interface LojaPerfil {
    idLojaPerfil: number;
    dsLojaPerfil: string;
}

export interface LojaCondicaoPagamento {
    idCondicaoPagamento: number;
    dsCondicaoPagamento: string;
    cdCondicaoPagamento: string;
}
export interface LojaRequest {
    dsRazaoSocial: string;
    dsNomeFantasia: string;
    dsCnpj: string;
    cdLoja: string;
    dsEmail: string;
    dsFone: string;
    dsObservacao: string;
    idCep?: number;
    dsEndereco: string;
    nrEndereco?: number;
    dsBairro: string;
    dsEstado: string;
    dsCidade: string;
    dsComplemento: string;
    dsInscricaoEstadual: string;
    fgAtivo: true;
    tipoLoja: TipoLoja | null;
    cep: Cep | null;
    dtInauguracao: string;
    portalTimezone: {
        idPortalTimezone: number;
    };
    grupoEconomicoLoja: GrupoEconomicoLoja | null;
    faixaFaturamento: FaixaFaturamento | null;
    lojaBandaPrecos?: LojaBandaPreco[];
    lojaConfiguracoes?: LojaConfiguracao[];
    lojaColunas?: ColunaDinamicaProps[];
    lojaPerfil: LojaPerfil | null;
    cdPontoComercial: string;
    lojaCondicaoPagamento: LojaCondicaoPagamento | null;
    clusterLoja: Cluster | null;
}

export interface Loja {
    idLoja: string;
    cdLoja: string;
    dsRazaoSocial: string;
    dsNomeFantasia: string;
    dsCnpj: string;
    dsGrupoEconomico: string;
    sgEstado: string;
    dsCidade: string;
    dsTipoLoja: string;
    fgAtivo: string;
}

export const initialValuesFormik: LojaRequest = {
    fgAtivo: true,
    dsRazaoSocial: '',
    dsNomeFantasia: '',
    dsCnpj: '',
    cdLoja: '',
    dsEmail: '',
    dsFone: '',
    dsEndereco: '',
    nrEndereco: 0,
    dsBairro: '',
    dsEstado: '',
    dsInscricaoEstadual: '',
    dsCidade: '',
    dsComplemento: '',
    dsObservacao: '',
    cdPontoComercial: '',
    dtInauguracao: new Date().toISOString(),
    lojaBandaPrecos: [],
    lojaConfiguracoes: [],
    lojaColunas: [],
    portalTimezone: {
        idPortalTimezone: 1,
    },
    cep: null,
    tipoLoja: null,
    lojaPerfil: null,
    faixaFaturamento: null,
    grupoEconomicoLoja: null,
    lojaCondicaoPagamento: null,
    clusterLoja: null,
};
